import React from "react";

import { cn } from "../../../common/u1/cn";
import { ClockIcon, MailIcon } from "../../../../assets/ui/icons";

/* "Reach out to us directly." The live rail card carries the same two facts — the support address and the hours — over a purple background image. */
export const SUPPORT_EMAIL = "info@trevex.io";
export const SUPPORT_HOURS = "9 AM – 6 PM GST, Mon – Fri";

/* One inset row: a gold-marked tile, a small caps label, the value under it. */
export const ContactRow = ({ label, icon, children }) => (
  <div
    className={cn(
      "flex items-center gap-3 rounded-xl border px-3 py-3",
      "border-[var(--support-row-line)] bg-[var(--support-row-bg)]"
    )}
  >
    <span
      aria-hidden="true"
      className={cn(
        "flex h-10 w-10 shrink-0 items-center justify-center rounded-[10px]",
        /* The gold the design gives these marks. Both icons inherit
           currentColor, so no per-icon override is needed. */
        "bg-[var(--support-tile-bg)] text-[var(--support-icon)]"
      )}
    >
      {icon}
    </span>

    <span className="min-w-0">
      <span
        className={cn(
          "block text-[10px] font-bold uppercase tracking-[.12em]",
          "text-[var(--support-eyebrow)] font-sans"
        )}
      >
        {label}
      </span>
      {children}
    </span>
  </div>
);

export const ContactCard = ({ className = "" }) => (
  <section
    aria-labelledby="u1-support-contact"
    className={cn(
      "relative overflow-hidden rounded-[16px] p-5 text-white",
      "bg-[image:var(--support-grad)]",
      className
    )}
  >
    {/* The faint angular wash the design puts behind the top-right corner.
        Decorative only. */}
    <span
      aria-hidden="true"
      className={cn(
        "pointer-events-none absolute -right-10 -top-6 h-32 w-32 rotate-[18deg]",
        "rounded-[28px] bg-white/[0.035]"
      )}
    />

    <p
      className={cn(
        "relative m-0 mb-2.5 text-[10.5px] font-bold uppercase tracking-[.14em]",
        "text-[var(--support-eyebrow)] font-sans"
      )}
    >
      We are here to help
    </p>
    <h2
      id="u1-support-contact"
      className="relative m-0 mb-4 text-[19px] font-bold leading-[1.3] font-sans"
    >
      Reach out to us directly
    </h2>

    <div className="relative flex flex-col gap-2.5">
      <ContactRow label="Email" icon={<MailIcon size={18} />}>
        <a
          href={`mailto:${SUPPORT_EMAIL}`}
          className="block truncate text-[15px] font-bold text-white font-sans hover:underline"
        >
          {SUPPORT_EMAIL}
        </a>
      </ContactRow>

      <ContactRow label="Hours" icon={<ClockIcon size={18} />}>
        <span className="block text-[15px] font-bold text-white font-sans">
          {SUPPORT_HOURS}
        </span>
      </ContactRow>
    </div>
  </section>
);

export default ContactCard;
